import type { Recipe } from '../../types'
import { image, ingredient, section } from '../helpers'

export const galetteComtoise: Recipe = {
  slug: 'galette-comtoise',
  title: 'Galette comtoise',
  category: 'sucré',
  description: 'Une galette comtoise traditionnelle, à la texture moelleuse et à la dorure brillante.',
  image: image('galette-comtoise'),
  tags: ['gâteau', 'fleur d’oranger', 'Comté'],
  meta: [
    { label: 'Préparation', value: '20 à 30 min' },
    { label: 'Cuisson', value: '20 + 20 min à 180 °C' },
  ],
  sections: [
    section('Ingrédients', [
      ingredient('lait', 'lait', '310 mL de lait', { amount: 310, unit: 'mL', shoppingKey: 'lait' }),
      ingredient('beurre', 'beurre', '100 g de beurre', { amount: 100, unit: 'g', shoppingKey: 'beurre' }),
      ingredient('sucre', 'sucre', '65 g de sucre', { amount: 65, unit: 'g', shoppingKey: 'sucre' }),
      ingredient('farine', 'farine', '160 g de farine', { amount: 160, unit: 'g', shoppingKey: 'farine' }),
      ingredient('œufs', 'œufs', '5 œufs', { amount: 5, unit: 'œuf', shoppingKey: 'œuf' }),
      ingredient('fleur', 'eau de fleur d’oranger', '4 c. à soupe d’eau de fleur d’oranger'),
      ingredient('sel', 'sel', '1 pincée (≈ 1 g) de sel'),
    ]),
  ],
  steps: [
    'Dans une casserole, mettre le lait, le sucre, le beurre et l’eau de fleur d’oranger. Chauffer jusqu’à ce que le beurre soit fondu.',
    'Hors du feu, ajouter la farine en fouettant. Remettre sur feu doux si nécessaire jusqu’à ce que la pâte se détache de la casserole.',
    'Transférer dans le bol du KitchenAid, monter la feuille et ajouter les œufs un à un en attendant que chaque œuf soit absorbé avant d’ajouter le suivant.',
    'Conserver un jaune d’œuf pour la dorure.',
    'Verser la préparation dans un moule adapté et enfourner 20 minutes à 180 °C. Sortir la galette, dorer avec le jaune dilué dans un peu de lait et scarifier la surface.',
    'Remettre au four pour 20 minutes supplémentaires.',
  ],
}
